import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { emptyObject } from 'ui-components/default-props/empty';
import { BulkActions } from '../../../../enums/bulk-actions';
import ShipFromDropdownContainer from './ship-from-dropdown/container';
import { ShipFromValidatorWithDefault } from './ship-from-dropdown/validator';
import { EXTERNAL_SHIP_FROM_PREFIX } from '../../../../store/csw/csw.fulfillment-plan-to-csw';

const BulkUpdateShipFrom = ({ onChange, model, jobData }) => {
  const { shippingConfiguration, externalFulfillmentConfiguration } = model || emptyObject;
  const { shipFromId } = shippingConfiguration || emptyObject;
  const { sellerFulfillmentProviderId } = externalFulfillmentConfiguration || emptyObject;
  const { bulkUpdateJobId } = jobData;

  const onShipFromSelected = useCallback(
    (id) => {
      const modelUpdate = id.includes(EXTERNAL_SHIP_FROM_PREFIX)
        ? {
            ...model,
            externalFulfillmentConfiguration: {
              sellerFulfillmentProviderId: id,
            },
            shippingConfiguration: undefined,
          }
        : {
            ...model,
            shippingConfiguration: {
              ...shippingConfiguration,
              shipFromId: id,
            },
            externalFulfillmentConfiguration: undefined,
          };
      onChange(modelUpdate);
    },
    [onChange, shippingConfiguration, model],
  );

  return (
    <ShipFromValidatorWithDefault selectedShipFromId={shipFromId || sellerFulfillmentProviderId}>
      {(validation) => (
        <ShipFromDropdownContainer
          bulkUpdateJobId={bulkUpdateJobId}
          onShipFromSelected={onShipFromSelected}
          selectedShipFromId={shipFromId || sellerFulfillmentProviderId}
          validation={validation}
        />
      )}
    </ShipFromValidatorWithDefault>
  );
};

BulkUpdateShipFrom.propTypes = {
  onChange: PropTypes.func.isRequired,
  model: PropTypes.object.isRequired,
  jobData: PropTypes.object.isRequired,
};

export default {
  id: BulkActions.shipFrom.name,
  render: (onChange, model, jobData, isEmpty) => {
    return <BulkUpdateShipFrom isEmpty={isEmpty} jobData={jobData} model={model} onChange={onChange} />;
  },
};
